export const locations = [
  {
    value: 'us',
    label: 'United States',
  },
  {
    value: 'pt',
    label: 'Portugal',
  },
  {
    value: 'de',
    label: 'Germany',
  },
  {
    value: 'gb',
    label: 'United Kingdom',
  },
  {
    value: 'fr',
    label: 'France',
  },
];